import axiosInstance from "app/axiosInstance";
import { KeyHistoryRequestDto } from "../entities/dtos/key-history-request.dto";
import { KeyHistoryResponseDto } from "../entities/dtos/key-history.dto";

export const getKeyHistory = async ({
  keyId,
  accountId
}: KeyHistoryRequestDto): Promise<KeyHistoryResponseDto> => {
  try {
    const response = await axiosInstance.get(
      `/accounts/${accountId}/keys/${keyId}/keystatus-history`
    );

    return response.data;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
